export default __webpack_public_path__ + "static/media/blue-shoe.d7124067.jpeg";